import React from "react";
import { CSVLink } from "react-csv";
import { useReportContext } from "../ReportDataContext";
import CampFilters, { useCampFilters } from "../CampFilters";
import CampReportTable from "./CampReportTable";
import { campHeaders } from "./CampCSVHeaders";
import { downloadCampSummarySheet } from "./campSummaryExcel";

export default function CampReportView({ reports }) {
  const branch = useReportContext().AUTH.branch;

  // The camp report endpoint returns the program name as `program_type`.
  const { filteredReports, filters } = useCampFilters(reports, branch, {
    programField: "program_type",
  });

  return (
    <div>
      <CampFilters filters={filters} />

      <div className="row mb-3">
        <div className="col-12 text-right">
          {filteredReports.length > 0 && (
            <button type="button" className="btn btn-primary">
              <CSVLink
                className="text-white"
                filename={`${branch.branch_name} - Registered Student List - Report.csv`}
                data={filteredReports}
                headers={campHeaders}
              >
                Download Report
              </CSVLink>
            </button>
          )}
          <button
            type="button"
            className="btn btn-primary ml-2"
            disabled={!filteredReports.length}
            onClick={() =>
              downloadCampSummarySheet(filteredReports, branch.branch_name)
            }
          >
            Download Summary
          </button>
        </div>
      </div>

      {filteredReports.length > 0 ? (
        <CampReportTable reports={filteredReports} showActions={false} />
      ) : (
        <div className="text-muted mt-3">No results match the selected filters.</div>
      )}
    </div>
  );
}
